<template>
  <div class="pagina-step">
    <div id="cofinanciamento-relatorio">
      <div
        class="floating-buttons"
        @mouseenter="showSidebarMenu = true"
        @mouseleave="showSidebarMenu = false"
      >
        <i class="icofont-navigation-menu menu-btn"></i>
        <ul v-show="showSidebarMenu">
          <li @click="voltar">
            <i class="icofont-arrow-left"></i> <span>Voltar</span>
          </li>
          <li @click="showModal = true">
            <i class="icofont-copy-invert"></i>
            <span> Ajude-nos a melhorar esse material</span>
          </li>
          <li @click="imprimirPagina()">
            <i class="icofont-print"></i> <span>Imprimir</span>
          </li>
        </ul>
      </div>

      <!-- Page 1 -->
      <div class="page">
        <div class="header-1">
          <h2 class="title-1">
            {{ nomeMunicipio }}
          </h2>
          <h2 class="title-1">
            OPORTUNIDADES PARA MAIS RECURSOS DO COFINANCIAMENTO FEDERAL NA APS
            MUNICIPAL
          </h2>

          <p class="text-center">
            Este relatório tem por objetivo apresentar de forma resumida as
            oportunidades para o município de <b>{{ nomeMunicipio }}</b
            >, maximizar o recebimento dos recursos do cofinanciamento federal
            da APS, o qual define os novos repasses federais aos municípios
            <b>a partir de maio de 2024</b>, conforme define a
            <b>Portaria n° 3493</b> de 10 de abril de 2024.
          </p>
        </div>

        <div class="substract">
          <h4>Resumo</h4>
          <p>
            O cofinanciamento federal da APS garante que o município não vai
            perder recursos, pelo menos no período de transição (abril de 2024 a
            abril de 2025). O desempenho municipal vai interferir diretamente no
            valor mensal e anual que o município vai receber. A projeção é de
            que o município possa ganhar ou perder um valor de até
            <b>
              R$
              {{
                diferencaMensalOtimoRegular.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </b>
            no repasse mensal ou até
            <b>
              R$
              {{
                diferencaAnualOtimoRegular.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </b>
            no repasse anual após o período de transição. Esse valor representa
            a diferença entre o desempenho <b>"ÓTIMO"</b> e o desempenho
            <b>"REGULAR"</b> que o município pode alcançar nos componentes
            qualidade, vínculo e acompanhamento. A realização de M & A na APS
            torna-se indispensável para monitorar e avaliar e, assim, evitar a
            perda de recursos federais para a APS.
          </p>
        </div>

        <div class="content-text">
          <h2 class="title-2 text-left">1 INTRODUÇÃO</h2>
          <p>
            O cofinanciamento federal da APS definido pela
            <b>Portaria n° 3493</b> de 10 de abril de 2024 se apresenta como uma
            atualização do modelo anterior que ficou vigente até abril de 2024.
            O cofinanciamento federal da APS é composto por 6 (seis)
            componentes:
          </p>
          <ol start="1" class="roman-list">
            <li>
              I. Fixo para manutenção ou custeio mensal de eSF e eAP e recurso
              de implantação em parcela única para eSF, eAP, eSB 40 horas e
              eMulti;
            </li>
            <li>II. Vínculo e acompanhamento territorial para eSF e eAP;</li>
            <li>III. Qualidade para eSF, eAP, eSB e eMulti;</li>
            <li>
              IV. Implantação e manutenção de programas, serviços, profissionais
              e outras composições de equipes que atuam na APS;
            </li>
            <li>V. Atenção à Saúde Bucal; e</li>
            <li>
              VI. Per capita de base populacional para ações no âmbito da APS.
            </li>
          </ol>

          <p>
            O município realiza <b>adesões</b> tanto no componente de
            <b>Atenção à Saúde Bucal</b>, quanto no componente de
            <b
              >implantação e manutenção de programas, serviços, profissionais e
              outras equipes que atuam na APS</b
            >. Nos demais componentes, não há adesão, porém é necessário atender
            aos requisitos estabelecidos nas normativas vigentes dos seis
            componentes mencionados.
          </p>

          <p>
            A classificação dos municípios do Brasil passa a ser realizada com
            base no Indicador de Equidade e Dimensionamento <b>(IED)</b>, que
            varia de <b>1 a 4</b>, o qual considera o Índice de Vulnerabilidade
            Social (IVS) e o porte populacional. O número 1 é utilizado para
            classificar municípios mais vulneráveis, enquanto o número 4
            representa municípios com menor vulnerabilidade.
            <b>{{ nomeMunicipio }}</b
            >, possui uma população de
            <b>{{ dados.etapa10.populacao }} pessoas</b>, estando inserida na
            <b>faixa</b> de municípios com
            <b>{{ portePopulacional }} habitantes</b> e possuindo a
            classificação <b>IED {{ ied }}</b
            >.
          </p>

          <!-- <p>
            O Quadro 1 faz um comparativo entre quanto
            {{ nomeMunicipio }} recebia no modelo anterior e quanto passa a
            receber no cofinanciamento federal da APS.
          </p> -->
        </div>
      </div>

      <!-- Page 2 -->
      <div class="page">
        <!-- <div class="container-table">
          <span
            >Quadro 1 – Comparativo entre o modelo anterior e o cofinanciamento
            federal atual da APS
          </span>
          <table>
            <thead>
              <tr>
                <th>MODELO ANTERIOR</th>
                <th>COFINANCIAMENTO FEDERAL APS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Recebia R$ 0,00. Não tinha essa previsão.</td>
                <td v-html="fixo.implantacao"></td>
              </tr>
              <tr>
                <td>Recebia R$ 0,00. Não tinha essa previsão.</td>
                <td v-html="fixo.custeio"></td>
              </tr>
              <tr>
                <td>
                  Recebia <b> R$ {{ capitacao_ponderada }} </b> na Capitação
                  Ponderada.
                </td>
                <td v-html="vinculo_e_acompanhamento[1].text"></td>
              </tr>
              <tr>
                <td>
                  Recebia: <br />
                  - <b>R$ {{ previne_brasil.pagamentoDesempenho }}</b> no
                  Pagamento por Desempenho; <br />
                  - <b>R$ {{ previne_brasil.indicadoresSaudeBucal }}</b> pelos
                  indicadores de saúde bucal; <br />
                  - <b>R$ 0,00</b> pelos indicadores da eMulti
                </td>
                <td v-html="qualidade[1].text"></td>
              </tr>
              <tr>
                <td>
                  Recebia <b>R$ {{ previne_brasil.informatizaAps }}</b> no
                  Informatiza APS.
                </td>
                <td>
                  Passa a receber no aumento dos recursos do novo modelo de
                  financiamento e tem também o SUS DIGITAL, mas não tem um
                  recurso específico para a informatização.
                </td>
              </tr>
              <tr>
                <td>
                  Recebia
                  <b>R$ {{ previne_brasil.pagamentoCriterioPopulacional }}</b>
                  de incentivo financeiro com base em critério populacional.
                </td>
                <td>
                  Passa a receber <b> R$ {{ perCapita }} </b> no componente per
                  capita de base populacional para ações no âmbito da APS.
                </td>
              </tr>
              <tr>
                <td>
                  Incentivo para as ações estratégicas. Valores definidos em
                  regras próprias de cada um.
                </td>
                <td>
                  Componente para implantação e manutenção de programas,
                  serviços, profissionais e outras composições de equipes que
                  atuam na APS. Valores definidos em regras próprias de cada um.
                </td>
              </tr>
              <tr>
                <td>Ações estratégicas: Saúde Bucal.</td>
                <td>Componente para atenção a Saúde Bucal.</td>
              </tr>
            </tbody>
          </table>
          <span class="fonte">{{ fonte }} </span>
        </div> -->

        <div class="content-text">
          <p>
            Segundo o CONASEMS (2024), os recursos da capitação ponderada, Saúde
            na Hora e informatização APS foram utilizados para compor o valor
            dos componentes fixos de manutenção (eSF, eAP, eSB e eMulti),
            juntamente com o componente de vínculo e acompanhamento (eSF e eAP).
            O componente de desempenho é formado pelos recursos dos indicadores
            (eSF, eAP, eSB e eMulti).
          </p>

          <p>
            Este relatório apresenta o
            <b style="color: red">valor mínimo</b> (quando o
            <b style="color: red">desempenho</b> municipal for
            <b style="color: red">"REGULAR"</b>) e
            <b style="color: green">máximo</b> (quando o
            <b style="color: green">desempenho</b> municipal for
            <b style="color: green">"ÓTIMO"</b>) que o município pode receber,
            levando em consideração especialmente os componentes: fixo de
            implantação e custeio, vínculo, acompanhamento e qualidade.
          </p>
        </div>
        <fixo :dados="dados" :fixo="fixo" :regras="regras.fixo" :fonte="fonte">
        </fixo>
        <vinculo-acompanhamento
          :dados="dados"
          :regras="regras.vinculo_e_acompanhamento"
          :fonte="fonte"
        ></vinculo-acompanhamento>
      </div>

      <!-- Page 3 -->
      <div class="page">
        <qualidade
          :dados="dados"
          :regras="regras.qualidade"
          :fonte="fonte"
        ></qualidade>

        <h2 class="title-2 text-left">
          5 Implantação e manutenção de programas, serviços, profissionais e
          outras equipes da APS.
        </h2>

        <div class="content-text">
          <p>
            Aqui, tem-se as mesmas regras das ações estratégicas definidas no
            modelo anterior. As regras individuais e próprias não mudaram e
            contemplará o custeio:
          </p>
          <ol start="1" class="roman-list">
            <li>I - das equipes Multiprofissionais - eMulti;</li>
            <li>II - das equipes de Consultório na Rua - eCR;</li>
            <li>III - das Unidades Básicas de Saúde Fluvial - UBSF;</li>
            <li>IV - das equipes de Saúde da Família Ribeirinha - eSFR;</li>
            <li>V - das equipes de Atenção Primária Prisional - eAPP;</li>
            <li>
              VI - para o ente federativo responsável pela gestão das ações de
              atenção integral à saúde dos adolescentes em situação de privação
              de liberdade;
            </li>
            <li>
              VII - do incentivo aos municípios com equipes de saúde integradas
              a programas de residência uniprofissional ou multiprofissional na
              Atenção Primária à Saúde;
            </li>
            <li>VIII - do Programa Saúde na Escola - PSE;</li>
            <li>
              IX - do incentivo financeiro federal de custeio para implementação
              de ações de atividade física no âmbito da APS - IAF;
            </li>
            <li>X - dos profissionais microscopistas;</li>
            <li>
              XI - da Estratégia de Agentes Comunitários de Saúde - ACS; e
            </li>
            <li>
              XII - de outros programas, serviços, profissionais e composições
              de equipe que venham a ser instituídos por meio de ato normativo
              específico do Ministério da Saúde.
            </li>
          </ol>
        </div>

        <h2 class="title-2 text-left">6 Saúde Bucal</h2>

        <div class="content-text">
          <p>
            A Saúde Bucal ganhou um componente próprio. No tempo em que o
            cofinanciamento federal da APS foi instituído, observou-se um
            aumento de recursos e uma maior valorização da Estratégia de Saúde
            Bucal (ESB). O componente para Atenção à Saúde Bucal contemplará o
            custeio:
          </p>
          <ol start="1" class="roman-list">
            <li>I - das equipes de Saúde Bucal - eSB;</li>
            <li>II - das Unidades Odontológicas Móveis - UOM;</li>
            <li>III - dos Centros de Especialidades Odontológicas - CEO;</li>
            <li>
              IV - dos Laboratórios Regionais de Prótese Dentária - LRPD; e
            </li>
            <li>V - dos Serviços de Especialidades em Saúde Bucal - Sesb.</li>
          </ol>
        </div>

        <h2 class="title-2 text-left">7 Per Capita</h2>

        <div class="content-text">
          <p>
            Esse componente per capita de base populacional continua como o
            anterior, sem mudanças no valor até o momento. Esse valor será
            calculado e divulgado anualmente. Para 2024, a PORTARIA GM/MS nº
            3732, DE 7 DE MAIO DE 2024, estabeleceu o valor de R$ 5,95 (cinco
            reais e noventa e cinco centavos) por pessoa.
          </p>
        </div>
      </div>

      <!-- Page 4 -->
      <div class="page">
        <h2 class="title-2 text-left">8 Desempenho do município</h2>

        <div class="content-text">
          <p>
            O desempenho municipal (qualidade, vínculo e acompanhamento) será
            medido com os conceitos qualitativos (<b
              >REGULAR, SUFICIENTE, BOM ou ÓTIMO</b
            >). Essa classificação vai interferir no valor total mensal e anual
            que o município receberá no cofinanciamento federal da APS.
          </p>
          <p>
            Durante o período de transição (maio de 2024 até abril de 2025), o
            município de
            <b>{{ nomeMunicipio }}</b
            >, está classificado como <b>"BOM"</b>. Pode ser que em maio de
            2025, na primeira classificação oficial, receba um <b>"REGULAR"</b>,
            se não iniciar desde já ações voltadas a atender os requisitos
            estabelecidos na Portaria nº 3493. A classificação
            <b>“REGULAR”</b> faria com que o município tivesse recursos federais
            reduzidos nos repasses mensais para a APS.
          </p>
          <p>
            <i
              >Para garantir que o município não venha a perder recursos,
              recomenda-se iniciar ações de M & A na APS de acordo com as
              recomendações do cofinanciamento federal da APS.</i
            >
          </p>
          <p>
            Considerando que, de acordo com o desempenho municipal (qualidade,
            vínculo e acompanhamento), a classificação muda e isso impacta o
            valor recebido em cada mês e no ano. Apresenta-se na sequência, os
            cenários para serem analisados.
          </p>

          <div>
            <h2 class="title-3 text-left">8.1 Regular</h2>

            <p>
              Na hipótese do desempenho municipal ser <b>“REGULAR”</b>, o quadro
              5 e o Gráfico 1 apresentam simulação dos valores a serem
              repassados por componente <b>mensalmente (a cada mês</b>) ao
              município. Esse é o menor valor que o município pode receber no
              cofinanciamento da APS.
            </p>

            <div class="row align-items-center">
              <div class="col-lg-12">
                <span style="text-transform: uppercase; font-weight: bold"
                  >Quadro 5, Gráfico 1 – Valores e percentuais na hipótese de
                  desempenho municipal “REGULAR”.</span
                >
              </div>
              <div class="col-lg-6">
                <tabela-descricao
                  :fixo="fixo"
                  :vinculoAcompanhamento="
                    vinculo_e_acompanhamento[3].valorTotal
                  "
                  :qualidade="qualidade[3].valorTotal"
                  :perCapita="perCapitaTotal"
                  :fonte="fonte"
                ></tabela-descricao>
              </div>
              <div class="col-lg-6">
                <!-- <span class="text-center d-block">Gráfico 1</span> -->
                <div class="grafico-tabela-revisao">
                  <apexchart
                    ref="chartPie"
                    type="pie"
                    width="360"
                    :options="chartPieOptions"
                    :series="chartPieSeriesRegular"
                  ></apexchart>
                </div>
              </div>
            </div>

            <p>
              É importante lembrar que, se o recurso estiver suspenso, esse
              valor pode ser ainda menor. Portanto, realizar o monitoramento e
              avaliação mensalmente, vai ajudar a atender aos requisitos
              estabelecidos e também evitar as suspensões de recursos federais
              para a APS municipal.
            </p>
          </div>

          <div class="mt-4">
            <h2 class="title-3 text-left">8.2 Suficiente</h2>

            <p>
              Na hipótese do desempenho municipal ser <b>“SUFICIENTE”</b>, o
              quadro 6 e o gráfico 2 apresentam simulação dos valores a serem
              repassados por componente <b>mensalmente (a cada mês)</b> ao
              município no cofinanciamento federal da APS.
            </p>

            <div class="row align-items-center">
              <div class="col-lg-12">
                <span style="text-transform: uppercase; font-weight: bold"
                  >Quadro 6, Gráfico 2 – Valores e percentuais na hipótese de
                  desempenho municipal "SUFICIENTE".</span
                >
              </div>
              <div class="col-lg-6">
                <tabela-descricao
                  :fixo="fixo"
                  :vinculoAcompanhamento="
                    vinculo_e_acompanhamento[2].valorTotal
                  "
                  :qualidade="qualidade[2].valorTotal"
                  :perCapita="perCapitaTotal"
                  :fonte="fonte"
                  numeroQuadro="6"
                  classificacao="Suficiente"
                ></tabela-descricao>
              </div>
              <div class="col-lg-6">
                <!-- <span class="text-center d-block">Gráfico 2</span> -->
                <div class="grafico-tabela-revisao">
                  <apexchart
                    ref="chartPie"
                    type="pie"
                    width="360"
                    :options="chartPieOptions"
                    :series="chartPieSeriesSuficiente"
                  ></apexchart>
                </div>
              </div>
            </div>

            <p>
              A classificação <b>“SUFICIENTE”</b>, também pode fazer o município
              perder recursos federais para a APS.
            </p>
          </div>
        </div>
      </div>

      <!-- Page 5 -->
      <div class="page">
        <div>
          <h2 class="title-3 text-left">8.3 Bom</h2>

          <div class="content-text">
            <p>
              Na hipótese do desempenho municipal ser <b>“BOM”</b>, o quadro 7 e
              o gráfico 3 apresentam simulação dos valores a serem repassados
              por componente <b>mensalmente (a cada mês)</b> ao município no
              cofinanciamento federal da APS.
            </p>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-12">
              <span style="text-transform: uppercase; font-weight: bold"
                >Quadro 7, Gráfico 3 – Valores e percentuais na hipótese de
                desempenho municipal "BOM".</span
              >
            </div>
            <div class="col-lg-6">
              <tabela-descricao
                :fixo="fixo"
                :vinculoAcompanhamento="vinculo_e_acompanhamento[1].valorTotal"
                :qualidade="qualidade[1].valorTotal"
                :perCapita="perCapitaTotal"
                :fonte="fonte"
                numeroQuadro="7"
                classificacao="Bom"
              ></tabela-descricao>
            </div>
            <div class="col-lg-6">
              <!-- <span class="text-center d-block">Gráfico 3</span> -->
              <div class="grafico-tabela-revisao">
                <apexchart
                  ref="chartPie"
                  type="pie"
                  width="360"
                  :options="chartPieOptions"
                  :series="chartPieSeriesSuficiente"
                ></apexchart>
              </div>
            </div>
          </div>

          <div class="content-text">
            <p>
              A classificação <b>“BOM”</b>, é bom para o município, pois será
              considerada automaticamente no período de maio de 2024 a abril de
              2025 (período de transição) e o município, provavelmente, não
              perde recursos federais na APS, mas ainda não é ótimo ter apenas a
              classificação <b>“BOM”</b>.
            </p>
            <p>
              Recomenda-se que as ações de gestores e profissionais de saúde da
              APS no território estejam alinhadas pelo objetivo de conseguir a
              classificação <b>“ÓTIMO”</b> que representa o máximo de desempenho
              conforme o novo modelo de cofinanciamento federal da APS.
            </p>
          </div>
        </div>
        <div class="mt-4">
          <h2 class="title-3 text-left">8.4 Ótimo</h2>

          <div class="content-text">
            <p>
              <i>
                Esse será o desempenho que todos, equipe gestora e profissionais
                de saúde (eSF, ACS, eAP, eSB e eMulti), devem perseguir como
                objetivo nos municípios.
              </i>
            </p>

            <p>
              O Quadro 8 e o Gráfico 4 apresentam simulação dos valores a serem
              repassados por <b>componente mensalmente (a cada mês)</b> ao
              município no cofinanciamento federal da APS, quando o desempenho
              for <b>“ÓTIMO”</b>.
            </p>

            <p>
              O objetivo do município é maximizar o recebimento dos recursos
              federais na Atenção Primária à Saúde (APS) e, com isso, garantir
              com qualidade a oferta das ações e serviços de saúde para a
              população em seu território.
            </p>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-12">
              <span style="text-transform: uppercase; font-weight: bold"
                >Quadro 8, Gráfico 4 – Valores e percentuais na hipótese de
                desempenho municipal "ÓTIMO".</span
              >
            </div>
            <div class="col-lg-6">
              <tabela-descricao
                :fixo="fixo"
                :vinculoAcompanhamento="vinculo_e_acompanhamento[0].valorTotal"
                :qualidade="qualidade[0].valorTotal"
                :perCapita="perCapitaTotal"
                :fonte="fonte"
                numeroQuadro="8"
                classificacao="Ótimo"
              ></tabela-descricao>
            </div>
            <div class="col-lg-6">
              <!-- <span class="text-center d-block">Gráfico 4</span> -->
              <div class="grafico-tabela-revisao">
                <apexchart
                  ref="chartPie"
                  type="pie"
                  width="360"
                  :options="chartPieOptions"
                  :series="chartPieSeriesOtimo"
                ></apexchart>
              </div>
            </div>
          </div>

          <div class="content-text">
            <p>
              <i
                >"Não se gerencia o que não se mede, não se mede o que não se
                define e não se define o que não se entende, ou seja, não há
                sucesso no que não se monitora, avalia, intervém e gerencia"</i
              >, esta citação é, regularmente, atribuída ao estatístico William
              Edwards Deming e nos diz que é preciso conhecer, definir,
              monitorar, avaliar, enfim, gerenciar para ter sucesso.
            </p>
            <p>
              Complementando, CONASEMS (2024), ressalta a necessidade de
              realizar monitoramento e avaliação com ferramentas de informática
              confiáveis como forma de melhorar a assistência à população e
              consequentemente atender aos requisitos estabelecidos no novo
              modelo de cofinanciamento federal da APS.
            </p>
            <p>
              Portanto, o uso do monitoramento e avaliação integrado ao processo
              de trabalho dos profissionais de saúde em equipe atuando de forma
              estratégica (eSF, ACS, eAP, eSB e eMulti) pode ajudar no objetivo
              de conseguir a classificação de desempenho
              <b>“ÓTIMO”</b> para as equipes e para o município.
            </p>
          </div>
        </div>
      </div>

      <!-- Page 6 -->
      <div class="page">
        <h2 class="title-3 text-left">8.5 Análise dos cenários</h2>

        <div class="content-text">
          <p>
            O Quadro 9 contém de forma consolidada
            <b>mensalmente (a cada mês)</b> uma comparação dos valores recebidos
            no modelo anterior e no cofinanciamento federal da APS. Nele,
            recomenda-se observar, especialmente se conforme o desempenho, o
            município tem aumento ou redução de repasses federais na APS.
            Valores negativos (com sinal de menos -) representam diminuição do
            valor em relação ao modelo de financiamento anterior.
          </p>

          <p v-html="textoTabelaPorcentagem"></p>

          <p>
            Portanto, para não perder recursos federais na APS, que pode
            acontecer se o desempenho for <b style="color: red">“REGULAR”</b> ou
            <b style="color: red">“SUFICIENTE”</b>, faz-se necessário trabalhar
            para um desempenho <b style="color: green">“ÓTIMO”</b> em cada
            equipe e consequentemente a nível municipal.
          </p>

          <tabela-porcentagem
            :data="dadosTabelaPorcentagem"
            :fonte="fonte"
          ></tabela-porcentagem>

          <p v-html="texto2TabelaPorcentagem"></p>

          <div class="mt-4">
            <span style="text-transform: uppercase; font-weight: bold"
              >Gráfico 5 - Total mensal de recursos do cofinanciamento federal
              da APS por classificação
            </span>
            <div id="chart">
              <apexchart
                class="chartBar"
                ref="chartPorcentagem"
                type="bar"
                height="350"
                :options="chartBarOptions"
                :series="chartSeriesTabelaPorcentagem"
              ></apexchart>
            </div>
            <span class="fonte d-block mb-3" v-html="fonte"></span>
          </div>

          <p v-html="texto3TabelaPorcentagem"></p>

          <div class="mt-4">
            <span style="text-transform: uppercase; font-weight: bold"
              >Gráfico 6 - Total anual de recursos do cofinanciamento federal da
              APS por classificação
            </span>
            <div id="chart">
              <apexchart
                class="chartBar"
                ref="chartPorcentagemAnual"
                type="bar"
                height="350"
                :options="chartBarOptions"
                :series="chartSeriesTabelaPorcentagemAnual"
              ></apexchart>
            </div>
            <span class="fonte d-block mb-3" v-html="fonte"></span>
          </div>

          <p>
            Espera-se que essas informações sobre os 4 (quatro) possíveis
            cenários de desempenho e seu impacto nos repasses mensais e anuais
            de recursos federais para a APS de {{ nomeMunicipio }}, possam
            ajudar no planejamento das ações.
          </p>
        </div>
      </div>

      <!-- Page 7 -->
      <div class="page">
        <mais-medicos
          :dados="dados"
          :fixo="fixo"
          :vinculoAcompanhamento="vinculo_e_acompanhamento"
          :fonte="fonte"
          classificacao="Bom"
        ></mais-medicos>

        <saude-bucal
          :dados="dados"
          :fixo="fixo"
          :fonte="fonte"
          classificacao="Bom"
        ></saude-bucal>
      </div>

      <!-- Page 8 -->
      <div class="page">
        <emulti
          :dados="dados"
          :fixo="fixo"
          :fonte="fonte"
          classificacao="Bom"
        ></emulti>

        <div class="content-text">
          <h2 class="title-3 text-left">9.4 Per capita</h2>
          <p>
            Segundo a Portaria 3732 de 7 de maio de 2024, o cálculo do valor
            mensal do incentivo financeiro com base em critério populacional foi
            realizado multiplicando-se o valor per capita anual, de que trata o
            caput, dividido por 12 (doze), utilizando os parâmetros da população
            dos municípios e do Distrito Federal de acordo com o Censo
            Populacional do ano de 2022 divulgada pelo Instituto Brasileiro de
            Geografia e Estatística - IBGE, vigente na data do cálculo, dividido
            por 12 (doze).
          </p>
          <p>No FNS, a ação detalhada pode ser:</p>
          <ul style="margin: 0 0 20px 60px">
            <li>
              1. “INCENTIVO FINANCEIRO DA APS - MANUTENÇÃO DE PAGAMENTO DE VALOR
              NOMINAL COM BASE EM EXERCÍCIO ANTERIOR”, porque o município teve
              decréscimo populacional e por isso ocorre a manutenção do valor
              nominal repassado no ano anterior; ou
            </li>
            <li>
              2. “INCENTIVO FINANCEIRO DA APS – COMPONENTE PER CAPITA DE BASE
              POPULACIONAL”, porque o município teve acréscimo populacional ou
              estabilidade populacional. A atualização de valor ocorreu mediante
              utilização dos dados populacionais de acordo com o censo IBGE
              2022.
            </li>
          </ul>
          <p>
            Lembrando que esse valor no FNS pode estar acumulado por causa de
            atrasos no repasse. Por exemplo, o valor da parcela financeira maio
            de 2024 é referente aos meses de janeiro a maio de 2024, ou seja, 5
            parcelas que ainda não tinham sido pagas.
          </p>
        </div>

        <conclusao
          :dados="dados"
          :nomeMunicipio="nomeMunicipio"
          :diferencaMensalOtimoRegular="diferencaMensalOtimoRegular"
          :diferencaAnualOtimoRegular="diferencaAnualOtimoRegular"
        ></conclusao>

        <div class="page-break"></div>
      </div>

      <!-- Page 9 -->
      <div class="page">
        <referencias></referencias>
      </div>
    </div>

    <b-modal
      id="formObservacao"
      v-model="showModal"
      title="Ajude-nos a melhorar esse material"
      centered
      scrollable
      hide-footer
    >
      <p class="my-4">
        <textarea
          name=""
          id=""
          class="form-control"
          rows="10"
          v-model="form.sugestao"
        ></textarea>
      </p>
      <button @click="salvarSugestao()">
        Salvar
        <b-spinner
          label="Spinning"
          small
          variant="white"
          v-if="loadingBtnSalvarSugestao"
        ></b-spinner>
      </button>
    </b-modal>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'
import Masks from '@/mixins/masks'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import TabelaDescricao from './components/TabelaDescricao.vue'
import TabelaPorcentagem from './components/TabelaPorcentagem.vue'
import Fixo from './components/Fixo.vue'
import VueApexCharts from 'vue-apexcharts'
import { regras } from './utils.js'
import VinculoAcompanhamento from './components/VinculoAcompanhamento.vue'
import Qualidade from './components/Qualidade.vue'
import MaisMedicos from './components/MaisMedicos.vue'
import SaudeBucal from './components/SaudeBucal.vue'
import Emulti from './components/Emulti.vue'
import Conclusao from './components/Conclusao.vue'
import Referencias from './components/Referencias.vue'

validations()

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    TabelaDescricao,
    TabelaPorcentagem,
    Fixo,
    apexchart: VueApexCharts,
    VinculoAcompanhamento,
    Qualidade,
    MaisMedicos,
    SaudeBucal,
    Emulti,
    Conclusao,
    Referencias,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      capitacao_ponderada: 0,
      fixo: {
        implantacao: '',
        custeio: '',
        valorImplantacao: 0,
        valorCusteio: 0,
      },
      vinculo_e_acompanhamento: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      qualidade: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      previne_brasil: {
        capitacaoPonderada: 0,
        pagamentoDesempenho: 0,
        informatizaAps: 0,
        indicadoresSaudeBucal: 0,
        indicadoresSaudeNaHora: 0,
        pagamentoCriterioPopulacional: 0,
      },
      perCapita: 0,
      perCapitaTotal: 0,
      dadosTabelaPorcentagem: [],
      showModal: false,
      loadingBtnSalvarSugestao: false,
      form: {
        sugestao: '',
      },
      chartPieSeriesRegular: [],
      chartPieSeriesSuficiente: [],
      chartPieSeriesBom: [],
      chartPieSeriesOtimo: [],
      chartPieOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: [
          'Fixo Implantação',
          'Fixo de custeio',
          'Qualidade',
          'Vínculo e acompanhamento',
          'Per capita',
        ],
        colors: ['#156082', '#E97132', '#196B24', '#0F9ED5', '#A02B93'],
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 350,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      chartSeriesTabelaPorcentagem: [],
      chartSeriesTabelaPorcentagemAnual: [],
      chartBarOptions: {
        xaxis: {
          categories: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (
                'R$ ' +
                val.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              )
            },
          },
        },
        colors: ['#22B14C', '#FFF200', '#FF7F27', '#ED1C24'],
        plotOptions: {
          bar: {
            columnWidth: '65%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              'R$ ' +
              val.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            )
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        legend: {
          show: false,
        },
      },
      regras: regras,
      textoTabelaPorcentagem: '',
      texto2TabelaPorcentagem: '',
      texto3TabelaPorcentagem: '',
      showSidebarMenu: false,
      diferencaMensalOtimoRegular: 0,
      diferencaAnualOtimoRegular: 0,
    }
  },
  mounted() {
    this.preencherRelatorio()
  },
  computed: {
    cidadeEstado() {
      return `${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },
    maskMoney() {
      return Masks['money']
    },
    nomeMunicipio() {
      return (
        this.dados.etapa1.cidade.no_municipio +
        ' – ' +
        this.dados.etapa1.estado.uf
      )
    },
    portePopulacional() {
      const labelSplit = this.dados.etapa3.porte_populacional.label.split('-')
      return labelSplit[1].trim().toLowerCase()
    },
    ied() {
      return this.dados.etapa3.ied.value
    },
    fonte() {
      let dataAtual = new Date()

      let nomesMeses = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ]

      let mesAtual = nomesMeses[dataAtual.getMonth()]

      let anoAtual = dataAtual.getFullYear()

      let mesAnoFormatado = mesAtual + '/' + anoAtual
      return `<b>Fonte</b>: Autoria própria, ${mesAnoFormatado}`
    },
  },
  methods: {
    preencherRelatorio() {
      const novasEquipes = this.dados.etapa5.equipes
      // componente fixo por implantação
      if (novasEquipes != null) {
        let somaComponenteFixoImplantacao = novasEquipes.reduce((acc, item) => {
          return acc + item.valor_implantacao * parseInt(item.value)
        }, 0)

        const quantEsf = novasEquipes.find((el) => el.key == 'esf')?.value
        const quantEAP30h = novasEquipes.find(
          (el) => el.key == 'eap_30h'
        )?.value
        const quantEAP20h = novasEquipes.find(
          (el) => el.key == 'eap_20h'
        )?.value
        const quantESB40h = novasEquipes.find(
          (el) => el.key == 'esb_40h'
        )?.value
        const quantEmultiAmpliada = novasEquipes.find(
          (el) => el.key == 'emulti_ampliada'
        )?.value
        const quantEmultiComplementar = novasEquipes.find(
          (el) => el.key == 'emulti_complementar'
        )?.value
        const quantEmultiEstrategica = novasEquipes.find(
          (el) => el.key == 'emulti_estrategica'
        )?.value
        this.fixo.implantacao = `
          Passa a receber <b>R$ ${somaComponenteFixoImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo implantação em parcela única. Esse valor considera: <b>${quantEsf} eSF</b>, <b>${quantEAP30h} eAP 30h</b>, <b>${quantEAP20h} eAP 20h</b>, <b>${quantESB40h} eSB 40h</b>, <b>${quantEmultiAmpliada} eMulti ampliada</b>, <b>${quantEmultiComplementar} eMulti complementar</b> e <b>${quantEmultiEstrategica} eMulti estratégica</b> novas que foram implantadas.
        `
        this.fixo.valorImplantacao = somaComponenteFixoImplantacao
      } else {
        this.fixo.implantacao =
          'O município não tem equipes novas a serem consideradas no componente fixo de implantação.'
      }

      const equipesImplantadas = this.dados.etapa4

      if (equipesImplantadas != null) {
        // componente fixo por custeio
        const ied = this.dados.etapa3.ied.value
        const valoresDasEquipesCusteio = this.regras.fixo.custeio.find(
          (item) => item.ied === ied
        )
        let somaComponenteCusteioImplantacao = 0
        valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
          let quantidadeDeEquipes = equipesImplantadas[element.label]
          somaComponenteCusteioImplantacao +=
            element.valor * quantidadeDeEquipes
        })

        // (3 eSF x R$ 16.000) + (0 eAP 30h x R$ 9.600,00) + (0 eAP 20h x R$ 6.400,00) = R$ 48.000,00

        this.fixo.custeio = `
          Passa a receber <b>R$ ${somaComponenteCusteioImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo de custeio. Esse valor considera: <b>${
          equipesImplantadas['eSF 40h']
        } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b>, <b>${
          equipesImplantadas['eAP 20h']
        } eAP 20h</b>.
        `
        this.fixo.valorCusteio = somaComponenteCusteioImplantacao

        // componente de vínculo e acompanhamento
        for (
          let index = 0;
          index < this.vinculo_e_acompanhamento.length;
          index++
        ) {
          const element = this.vinculo_e_acompanhamento[index]
          let val = this.valoresComponenteVinculoAcompanhamento(
            equipesImplantadas,
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }

        // Componente de qualidade
        for (let index = 0; index < this.qualidade.length; index++) {
          const element = this.qualidade[index]
          let val = this.valoresComponenteQualidade(
            equipesImplantadas,
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }
      }

      //capitação ponderada
      this.capitacao_ponderada =
        this.dados.etapa6.capitacaoPonderada.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // pagamento por desempenho
      this.previne_brasil.pagamentoDesempenho =
        this.dados.etapa6.pagamentoDesempenho.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })
      // indicadores saúde bucal
      this.previne_brasil.indicadoresSaudeBucal =
        this.dados.etapa6.indicadoresSaudeBucal.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // informatiza aps
      this.previne_brasil.informatizaAps =
        this.dados.etapa6.informatizaAps.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // pagamento critério populacional
      this.previne_brasil.pagamentoCriterioPopulacional =
        this.dados.etapa6.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // per capita
      this.perCapita =
        this.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      this.perCapitaTotal = this.dados.etapa6.pagamentoCriterioPopulacional

      // Dados gráfico Regular
      this.chartPieSeriesRegular = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[3].valorTotal,
        this.vinculo_e_acompanhamento[3].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Suficiente
      this.chartPieSeriesSuficiente = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[2].valorTotal,
        this.vinculo_e_acompanhamento[2].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Bom
      this.chartPieSeriesBom = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[1].valorTotal,
        this.vinculo_e_acompanhamento[1].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Ótimo
      this.chartPieSeriesOtimo = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[0].valorTotal,
        this.vinculo_e_acompanhamento[0].valorTotal,
        this.perCapitaTotal,
      ]

      this.formatarDadosDaTabelaPorcentagem()
    },

    valoresComponenteVinculoAcompanhamento(equipesImplantadas, classificacao) {
      let somaComponenteVinculoAcompanhamento = 0
      for (let label in equipesImplantadas) {
        const resultado = this.regras.vinculo_e_acompanhamento.find(
          (item) => item.label === label
        )
        if (resultado) {
          const classificacaoEquipe = resultado.classificacao.find(
            (el) => el.tipo === classificacao
          )
          let quantidadeDeEquipes = equipesImplantadas[label]
          somaComponenteVinculoAcompanhamento +=
            classificacaoEquipe.valor * quantidadeDeEquipes
        }
      }
      let text = `
        Passa a receber <b>R$ ${somaComponenteVinculoAcompanhamento.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )}</b> de vinculo e
              acompanhamento pela classificação ${classificacao.toUpperCase()} na transição entre maio
              de 2024 e maio de 2025. Após isso, o município pode melhorar sua
              classificação e aumentar mais esse valor. Esse valor considera: <b>${
                equipesImplantadas['eSF 40h']
              } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b> e <b>${
        equipesImplantadas['eAP 20h']
      } eAP 20h</b> novas que foram implantadas.`
      return {
        text: text,
        total: somaComponenteVinculoAcompanhamento,
      }
    },

    valoresComponenteQualidade(equipesImplantadas, classificacao) {
      let somaComponenteQualidade = 0
      for (let label in equipesImplantadas) {
        const resultado = this.regras.qualidade.find(
          (item) => item.label === label
        )
        if (resultado) {
          const classificacaoEquipe = resultado.classificacao.find(
            (el) => el.tipo === classificacao
          )
          let quantidadeDeEquipes = equipesImplantadas[label]
          somaComponenteQualidade +=
            classificacaoEquipe.valor * quantidadeDeEquipes
        }
      }
      let text = `
            Passa a receber <b>R$ ${somaComponenteQualidade.toLocaleString(
              'pt-BR',
              {
                minimumFractionDigits: 2,
              }
            )}</b> de qualidade pela classificação “BOM” na transição entre maio
                  de 2024 e maio de 2025. Após isso, o município pode melhorar sua
                  classificação e aumentar mais esse valor. Esse valor considera: <b>${
                    equipesImplantadas['eSF 40h']
                  } eSF 40h</b>, <b>${
        equipesImplantadas['eAP 30h']
      } eAP 30h</b>, <b>${equipesImplantadas['eAP 20h']} eAP 20h</b>, <b>${
        equipesImplantadas['eMulti Ampliada']
      } eMulti ampliada</b>,
      <b>${equipesImplantadas['eMulti Complementar']} eMulti complementar</b>,
      <b>${equipesImplantadas['eMulti Estratégica']} eMulti estratégica</b>,
                  <b>${equipesImplantadas['eSB I - Comum']} eSB I - Comum</b>,
                  <b>${equipesImplantadas['eSB II - Comum']} eSB II - Comum</b>,
                  <b>${
                    equipesImplantadas['eSB I- Quil/Assent']
                  } eSB I- Quil/Assent</b>,
                  <b>${
                    equipesImplantadas['eSB II- Quil/Assent']
                  } eSB II- Quil/Assent</b>
                  novas que foram implantadas.
            `
      return {
        text: text,
        total: somaComponenteQualidade,
      }
    },

    formatarDadosDaTabelaPorcentagem() {
      let dataClassificacao = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
      let data = []
      for (let index = 0; index < dataClassificacao.length; index++) {
        // classificação
        const classificacao = dataClassificacao[index]
        // vinculo e acompanhamento
        let vinculoAcompanhamento = 0
        let valorVinculoAcompanhamento = this.vinculo_e_acompanhamento.find(
          (item) => item.classificacao === classificacao
        )
        if (valorVinculoAcompanhamento) {
          vinculoAcompanhamento = valorVinculoAcompanhamento.valorTotal
        }
        // qualidade
        let qualidade = 0
        let valorQualidade = this.qualidade.find(
          (item) => item.classificacao === classificacao
        )
        if (valorQualidade) {
          qualidade = valorQualidade.valorTotal
        }
        // recebia
        let recebia = 0
        for (const key in this.dados.etapa6) {
          const element = this.dados.etapa6[key]
          recebia += element
        }
        // passa a receber
        const passaAreceber =
          this.fixo.valorImplantacao +
          this.fixo.valorCusteio +
          vinculoAcompanhamento +
          qualidade +
          this.perCapitaTotal
        // aumentou
        let aumentou = passaAreceber - recebia
        // percentual
        const result = (aumentou / recebia) * 100
        const aumentouPercentual = result.toFixed(2)

        data.push({
          recebia: recebia,
          desempenho: classificacao,
          passaAreceber: passaAreceber,
          aumentou: passaAreceber - recebia,
          aumentouPercentual: aumentouPercentual,
        })
      }

      const otimo = data.find((el) => el.desempenho === 'Ótimo')
      const bom = data.find((el) => el.desempenho === 'Bom')
      const suficiente = data.find((el) => el.desempenho === 'Suficiente')
      const regular = data.find((el) => el.desempenho === 'Regular')
      const diferenca = otimo.passaAreceber - regular.passaAreceber
      this.diferencaMensalOtimoRegular = diferenca

      this.textoTabelaPorcentagem = `
        No cenário de pior desempenho, <b style="color: red">“REGULAR”</b>, o município recebe o valor
            de <b style="color: red">R$
            ${regular.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>
            e no cenário de melhor desempenho, <b style="color: green">“ÓTIMO”</b>, o município recebe o
            valor de <b style="color: green">R$
            ${otimo.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>. A diferença de <b style="color: ${
        diferenca < 0 ? 'red' : 'green'
      }"> R$
            ${diferenca.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b> está
            relacionada aos componentes de vínculo e acompanhamento e qualidade
            que são os valores variáveis do cofinanciamento federal na APS.

      `
      this.texto2TabelaPorcentagem = `
        No Gráfico 5, pode-se observar que o valor de R$ ${diferenca.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por mês</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.dadosTabelaPorcentagem = data

      this.$refs.chartPorcentagem.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber,
            bom.passaAreceber,
            suficiente.passaAreceber,
            regular.passaAreceber,
          ],
        },
      ])

      const diferencaAnualEntreOtimoRegular =
        otimo.passaAreceber * 12 - regular.passaAreceber * 12
      this.diferencaAnualOtimoRegular = diferencaAnualEntreOtimoRegular
      this.texto3TabelaPorcentagem = `
        No Gráfico 6, pode-se observar que o valor de R$ ${diferencaAnualEntreOtimoRegular.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por ano</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.$refs.chartPorcentagemAnual.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber * 12,
            bom.passaAreceber * 12,
            suficiente.passaAreceber * 12,
            regular.passaAreceber * 12,
          ],
        },
      ])
    },

    async salvarSugestao() {
      try {
        this.loadingBtnSalvarSugestao = true
        const response = await this.$apiPublic.post(
          '/cofinanciamento-2024/sugestao',
          {
            ibge: this.dados.etapa1.cidade.co_ibge,
            email: this.dados.etapa2.email,
            sugestao: this.form.sugestao,
          }
        )
        if (response.data.error == false) {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topCenter',
          })
        } else {
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topCenter',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showModal = false
        this.loadingBtnSalvarSugestao = false
      }
    },

    imprimirPagina() {
      window.print()
    },

    voltar() {
      this.$emit('etapa-anterior')
    },

    proximo() {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.imprimir()
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style>
.Etapa10 {
  height: auto !important;
}
</style>
<style lang="scss">
@media print {
  @page {
    margin: 8mm 15mm;
  }
}

#cofinanciamento-relatorio {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  text-align: justify;
  counter-reset: page 0;
  @media print {
    font-size: 18px;
  }

  .col-lg-6 {
    width: 50%;
  }

  .header {
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    @media print {
      display: none;
    }
    @media screen and (max-width: 665px) {
      width: 100%;
    }
    button {
      height: auto;
    }
  }

  .page {
    position: relative;
    width: 210mm;
    min-height: 297mm;
    padding: 10mm;
    margin: 10mm auto;
    border: 1px #d3d3d3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    counter-increment: page;

    @media screen and (max-width: 665px) {
      width: 100%;
      padding: 15px;
    }
    @media print {
      position: relative;
      padding: 0mm;
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      // page-break-after: always;
    }

    // &::before {
    //   content: counter(page);
    //   position: absolute;
    //   bottom: 10mm;
    //   right: 10mm;
    // }

    .title-1 {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      margin: 0;
      @media print {
        font-size: 22px;
        margin-top: 20px;
      }
    }

    .title-2 {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      margin: 30px 0 0 0;
      text-transform: uppercase;
      &.text-left {
        margin-bottom: 15px;
      }
      @media print {
        font-size: 20px;
        margin-top: 30px;
      }
    }

    .title-3 {
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      margin: 0;
      &.text-left {
        margin-bottom: 15px;
      }
      @media print {
        font-size: 18px;
        margin-top: 20px;
      }
    }

    .header-1 {
      display: flex;
      flex-direction: column;
      gap: 50px;
    }

    .substract {
      margin: 10px 0 20px 0;
      h4 {
        font-size: 14px;
        font-weight: 700;
        @media print {
          font-size: 18px;
        }
      }
    }

    .content-text {
      p {
        text-indent: 12mm;
      }
      .roman-list {
        list-style-type: none;
        margin: 0 12mm 5mm 12mm;
      }
    }

    .container-table {
      @media print {
        margin-bottom: 15px;
      }
      @media screen and (max-width: 1024px) {
        overflow: scroll;
      }
      span {
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
      table {
        width: 100%;
        border: 1px solid;
        border-collapse: collapse;

        th {
          border: 1px solid black;
          text-align: center;
        }
        td {
          border: 1px solid black;
          padding: 10px;
        }
      }
    }

    .page-break {
      page-break-before: always;
      counter-increment: page;
    }
  }

  .floating-buttons {
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 999;
    @media print {
      display: none;
    }
    .menu-btn {
      background-color: #1178b3;
      padding: 15px;
      color: #fff;
      font-size: 20px;
    }
    ul {
      position: relative;
      top: 12px;
      li {
        padding: 15px;
        font-size: 14px;
        cursor: pointer;
        color: #fff;
        background-color: #1178b3;
        &:hover {
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
      }
    }
  }
}
.grafico-tabela-revisao {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
#formObservacao button {
  float: right;
  width: auto;
}
</style>
